import { render, staticRenderFns } from "./ModalPreloaderBanner.vue?vue&type=template&id=2583f93f&lang=pug&"
import script from "./ModalPreloaderBanner.vue?vue&type=script&lang=js&"
export * from "./ModalPreloaderBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports